import {createApp} from 'vue'
import HelpHint from '@/components/HelpHint.vue'
import App from './App.vue'
import Tooltip from './directives/Tooltip';
import Permission from './directives/permission';
import store from './store';
import router from './router';
import vuetify from './plugins/vuetify';
import { checkAndCleanConflictingTokens } from './utils/auth-cleanup';
import { installClientLog, watchClient } from './utils/clientLog';
import apiClient from './apiClient';
import apiDataClient from './apiDataClient';

// Fix ResizeObserver loop completed with undelivered notifications error
const resizeObserverLoopErrRe = /^[^(ResizeObserver loop completed with undelivered notifications.)]/
const resizeObserverErrFilter = (e) => e.message ? resizeObserverLoopErrRe.test(e.message) : true
window.addEventListener('error', e => {
  if (!resizeObserverErrFilter(e)) {
    e.stopImmediatePropagation()
  }
})

// Check for conflicting tokens and clean up if needed
checkAndCleanConflictingTokens();

// Skip auth initialization for certain public pages to prevent unwanted auto-login
const publicPaths = ['/reset-password/', '/confirm/', '/verify-email/'];
const isPublicPage = publicPaths.some(path => window.location.pathname.startsWith(path));

if (!isPublicPage) {
  store.dispatch('initializeAuth');
} else {
  // For public pages, just mark as initialized without checking auth
  store.commit('setAuthInitialized', true);
}

// journal of the page for «Сообщить об ошибке»
installClientLog(router);
watchClient(apiClient, 'core');
watchClient(apiDataClient, 'data');

const app = createApp(App);
// «?» next to hard places of the screens, leads to the help (/help)
app.component('HelpHint', HelpHint);
app.directive('tooltip', Tooltip);
app.directive('permission', Permission);
app.use(store);
app.use(router);
app.use(vuetify);
app.mount('#app');

